export default "__VITE_ASSET__CfdN4jVs__"